import { Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap'
import { getProperty } from '../../Services/ClientService';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import Table from '../../CustomComponent/Tables/Table';
import { TableColumn } from 'react-data-table-component';
import { MoreVertical, Eye } from 'lucide-react';
import { useParams } from 'react-router-dom';

export default function Property() {
    const { propertyId } = useParams()
    const [client, setClient] = useState<any>(null);
    const [clientId, setClientId] = useState<any>(null)
    const [property, setProperty] = useState<any>([]);
    const [meters, setMeters] = useState<any>([]);

    useEffect(() => {
        const storedClient = localStorage.getItem('selectedClient');
        if (storedClient) {
            setClientId(storedClient)
        }
    }, []);

    useEffect(() => {
        if (clientId && propertyId) fetchProperty();
    }, [clientId, propertyId]);

    const ActionDropdown = ({ row }: { row: any }) => {
        const [dropdownOpen, setDropdownOpen] = useState(false);
        const toggle = () => setDropdownOpen(prevState => !prevState);

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                <DropdownToggle color="transparent" className="p-0 border-0 shadow-none">
                    <MoreVertical size={18} />
                </DropdownToggle>
                <DropdownMenu end>
                    <DropdownItem onClick={() => console.log('View', row)}>
                        <Eye size={16} color="green" className="me-2" />
                        View
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    };

    const tableColumns: TableColumn<any>[] = [
        {
            name: "S/N",
            cell: (_row, index) => index + 1,
            sortable: false,
            width: '70px',
        },
        {
            name: "Meter Name",
            selector: (row) => row.name,
            sortable: true,
            center: false,
            wrap: true,
            width: '170px',
        },
        {
            name: "Type",
            selector: (row) => row.meter_type,
            sortable: true,
            center: false,
            wrap: true,
            width: '120px',
            // color: 'orange'
        },
        {
            name: "Meter Number",
            selector: (row) => (
                <div>
                    <div>{row.meter_no_1 || ''}</div>
                    <div>{row.meter_no_2 || ''}</div>
                </div>
            ),
            sortable: true,
            center: false,
            wrap: true,
            width: '170px',
        },
        {
            name: "Site ID.",
            selector: (row) => `${row.site_id}`,
            sortable: true,
            center: false,
            wrap: true,
            width: '170px',
            // width: '200px',
        },
        {
            name: "Utility",
            cell: (row) => row.utility?.name || '',
            sortable: false,
            center: false,
        },
        {
            name: "Data Collector",
            cell: (row) => row.data_collector || '',
            sortable: false,
            center: false,
        },
        {
            name: "Meter Operator",
            cell: (row) => row.meter_operator || '',
            sortable: false,
            center: false,
        },
        {
            name: "Status",
            cell: (row) => row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : '',
            sortable: false,
            center: true,
        },
        {
            name: 'Actions',
            cell: (row) => <ActionDropdown row={row} />,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '70px',
        },
    ];

    const fetchProperty = async () => {
        try {
            const response = await getProperty(propertyId!);
            setProperty(response)
            setMeters(response.meters);
            setClient(response.client);
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch Properties");
        }
    };

    return (
        <>
            <Breadcrumbs pageTitle='Property' />
            <Container className='default-dashboard' fluid>
                {property && (
                    <Row className="mb-4">
                        <Col sm="12">
                            <div className="p-4 border border-primary rounded shadow-sm">
                                <Row className="gy-3">
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Company Name</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client?.name}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Property</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{property?.name}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">No. of Meters</small>
                                            <div className="text-primary fw-bold">{meters?.length}</div>
                                        </div>
                                    </Col>
                                    <Col lg="8" md="12">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Address</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client?.address}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                )}

                <Row>
                    <Table title='Meter' tableColumns={tableColumns} data={meters} />
                </Row>
            </Container>
        </>
    );
}